import { CheckCircle2, RefreshCw } from "lucide-react";
import React from "react";
import { Badge } from "@/components/ui/badge";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { ScaledThumbnail } from "./ScaledThumbnail";

interface LastSyncCardThumbnailProps {
  isHovered?: boolean;
  alwaysVisible?: boolean;
}

export default function LastSyncCardThumbnail({
  isHovered = false,
  alwaysVisible = false,
}: LastSyncCardThumbnailProps) {
  return (
    <ScaledThumbnail
      isHovered={isHovered}
      alwaysVisible={alwaysVisible}
      contentWidth={380}
    >
      <Card className="w-[380px]">
        <CardHeader>
          <div className="flex items-start justify-between">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-primary/10 rounded-lg">
                <RefreshCw className="h-5 w-5 text-primary" />
              </div>
              <div>
                <CardTitle className="text-lg">Last Sync</CardTitle>
                <CardDescription>All data sources</CardDescription>
              </div>
            </div>
            <Badge variant="default" className="gap-1">
              <CheckCircle2 className="h-3 w-3" />
              Up to date
            </Badge>
          </div>
        </CardHeader>
        <CardContent>
          <div className="space-y-1 text-sm">
            <p className="text-muted-foreground">
              Last sync:{" "}
              <span className="text-foreground font-medium">2 minutes ago</span>
            </p>
            <p className="text-muted-foreground">
              Synced:{" "}
              <span className="text-foreground font-medium">
                19,624 records
              </span>
            </p>
            <p className="text-muted-foreground">
              Next sync scheduled for 06:00 daily
            </p>
          </div>
        </CardContent>
      </Card>
    </ScaledThumbnail>
  );
}

export { LastSyncCardThumbnail };
